import { get, isEmpty } from "lodash";
import { useEffect } from "react";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";

type UseIntlValidationProps<T extends FieldValues> = {
  formMethods: UseFormReturn<T>;
  triggerField: Path<T>;
  validationFields: Path<T>[];
};

export const useIntlValidation = <T extends FieldValues>({
  formMethods,
  triggerField,
  validationFields,
}: UseIntlValidationProps<T>) => {
  const {
    trigger,
    formState: { touchedFields },
    watch,
  } = formMethods;

  const triggerValue = watch(triggerField);

  useEffect(() => {
    validationFields.forEach((field) => {
      const validationFieldValue = watch(field);
      if (get(touchedFields, field) || !isEmpty(validationFieldValue)) {
        trigger(field);
      }
    });
  }, [triggerValue]);
};
